"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
function processTableTotal(tableHeaders, tableData, nodeName, addNodeName, color) {
    if (addNodeName === void 0) { addNodeName = false; }
    if (color === void 0) { color = false; }
    if (!tableData || tableData.length < 1) {
        return;
    }
    var totalRow = { name: addNodeName ? nodeName + ' - Total' : 'Total' };
    tableHeaders.forEach(function (header) {
        totalRow[header.key] = tableData.reduce(function (s, row) {
            return s + row[header.key];
        }, 0);
    });
    if (color) {
        totalRow.color = tableData[0].color;
    }
    return totalRow;
}
function getFilterKey(cateName, isIO) {
    if (isIO === void 0) { isIO = false; }
    var filterKey = isIO ? "filter_io_" + cateName : "filter_" + cateName;
    return filterKey;
}
function getFilterCategory(filter) {
    // Example: '(Region:Europe or Region:US or Region:Asia)'
    var entries = filter.trim().replace(/[()]/, '').split('or');
    if (entries && entries.length > 0) {
        return entries[0].split(':')[0].trim();
    }
    return null;
}
function getFilterNumericObject(filter) {
    // Example: 'Outputs:revenueYear10:$gt:0:npdModelv3slider:MjAyNyBSZXZlbnVl'
    var filterGrids = filter.split(':');
    var field = filterGrids[0], key = filterGrids[1], operator = filterGrids[2], value = filterGrids[3], template = filterGrids[4], codedDisplay = filterGrids[5];
    var display = atob(codedDisplay);
    if (display && key && field) {
        return {
            'key': key.trim(),
            'display': display.trim(),
            'field': field.trim()
        };
    }
    return null;
}
function addFiltersToHeaders(tableHeaders, filterCategories) {
    filterCategories.forEach(function (cate) {
        tableHeaders.push({
            'key': getFilterKey(cate),
            'text': "Filter: " + cate
        });
    });
}
function addNumericalFiltersToHeaders(tableHeaders, filterNumericObjects) {
    filterNumericObjects.forEach(function (numericObject) {
        tableHeaders.push({
            'key': getFilterKey(numericObject.key, true),
            'text': "Filter: " + numericObject.display
        });
    });
}
function processRowWithFilters(row, filterCategories) {
    if (!row.tags) {
        return;
    }
    var tags = row.tags.filter(function (t) { return t !== 'all'; });
    tags.sort();
    filterCategories.forEach(function (cate) {
        var cateResult = [];
        tags.forEach((function (tag) {
            var _a = tag.split(':'), c = _a[0], t = _a[1];
            if (c === cate) {
                cateResult.push(t);
            }
        }));
        row[getFilterKey(cate)] = cateResult.join(',');
    });
}
function processRowWithNumericalFilters(row, filterNumericObjects) {
    if (!row.reportOptionNumerics) {
        return;
    }
    var IOdata = row.reportOptionNumerics;
    filterNumericObjects.forEach(function (numericObject) {
        if (numericObject.field in IOdata && numericObject.key in IOdata[numericObject.field]) {
            var numResult = IOdata[numericObject.field][numericObject.key];
            row[getFilterKey(numericObject.key, true)] = numResult;
        }
    });
}
function processTableWithFilters(tableData, filterItems, filterType) {
    if (filterType === void 0) { filterType = 'category'; }
    if (!tableData || tableData.length < 1) {
        return;
    }
    if (filterType === 'numerical') {
        tableData.forEach(function (row) {
            processRowWithNumericalFilters(row, filterItems);
        });
    }
    else {
        tableData.forEach(function (row) {
            processRowWithFilters(row, filterItems);
        });
    }
}
function addColorToHeaders(tableHeaders, colorKey) {
    if (colorKey) {
        tableHeaders.push({
            'key': 'colorTag',
            'text': "Color By: " + colorKey.replace(/[<>]/g, '')
        });
    }
}
function joinMainAndSibling(mainTable, siblingTable, mainNodeName, siblingNodeName) {
    var joinedTable = mainTable.map(function (row) { return ({ main: row }); });
    if (siblingTable && siblingTable.length > 0) {
        joinedTable.forEach(function (row) {
            var i = 0;
            while (i < siblingTable.length) {
                if (siblingTable[i].name === row.main.name) {
                    row.sibling = siblingTable[i];
                    siblingTable.splice(i, 1);
                    break;
                }
                i++;
            }
        });
        siblingTable.forEach(function (row) {
            joinedTable.push({ sibling: row });
        });
        joinedTable.forEach(function (row) {
            if (row.main) {
                row.main.name = mainNodeName + ' - ' + row.main.name;
            }
            if (row.sibling) {
                row.sibling.name = siblingNodeName + ' - ' + row.sibling.name;
            }
        });
    }
    return joinedTable;
}
function joinMainAndSiblingIndexWise(mainTable, siblingTable, mainNodeName, siblingNodeName, isLeafNodeData) {
    if (isLeafNodeData === void 0) { isLeafNodeData = false; }
    var joinedTable = [];
    var maxLength = Math.max(mainTable ? mainTable.length : 0, siblingTable ? siblingTable.length : 0);
    for (var i = 0; i < maxLength; i++) {
        var row = {};
        if (mainTable && i < mainTable.length) {
            row.main = __assign({}, mainTable[i]);
            row.main.name = isLeafNodeData ? mainNodeName : mainNodeName + ' - ' + row.main.name;
        }
        if (siblingTable && i < siblingTable.length) {
            row.sibling = __assign({}, siblingTable[i]);
            row.sibling.name = isLeafNodeData ? siblingNodeName : siblingNodeName + ' - ' + row.sibling.name;
        }
        joinedTable.push(row);
    }
    return joinedTable;
}
function formatCell(val, decimalPoint) {
    if (typeof val === 'undefined' || val === null) {
        return '""';
    }
    var str = val.toString().trim();
    if (!isNaN(val)) {
        return str.replace('.', decimalPoint);
    }
    return "\"" + str + "\"";
}
var ChartTable = /** @class */ (function () {
    function ChartTable() {
    }
    ChartTable.generateTable = function (_a) {
        var inputData = _a.inputData, mainNodeName = _a.mainNodeName, siblingNodeName = _a.siblingNodeName, reportOptions = _a.reportOptions, _b = _a.hidePortfolioElements, hidePortfolioElements = _b === void 0 ? false : _b, _c = _a.terminology, terminology = _c === void 0 ? null : _c;
        var tableHeaders = inputData.headerMap;
        var mainTable = inputData.mainRows;
        var siblingTable = inputData.siblingRows;
        var shouldTotal = inputData.shouldTotal;
        var totalRow = { main: undefined, sibling: undefined };
        if (shouldTotal) {
            totalRow.sibling = processTableTotal(tableHeaders, siblingTable, siblingNodeName, true, true);
            totalRow.main = processTableTotal(tableHeaders, mainTable, mainNodeName, totalRow.sibling != null);
        }
        var filterLogic = reportOptions.filterLogic, groupKey = reportOptions.groupKey, colorKey = reportOptions.colorKey;
        if (filterLogic && !groupKey) {
            var filterLogicArray = filterLogic.split(' and ');
            var filterCategories = filterLogicArray
                .filter(function (filter) { return (filter.includes(' or ') || filter.split(':').length !== 6); })
                .map(function (filter) { return getFilterCategory(filter); });
            var filterNumericObjects = filterLogicArray
                .filter(function (filter) { return (!filter.includes(' or ') && filter.split(':').length === 6); })
                .map(function (filter) { return getFilterNumericObject(filter); });
            addFiltersToHeaders(tableHeaders, filterCategories);
            addNumericalFiltersToHeaders(tableHeaders, filterNumericObjects);
            processTableWithFilters(mainTable, filterCategories);
            processTableWithFilters(mainTable, filterNumericObjects, 'numerical');
            processTableWithFilters(siblingTable, filterCategories);
            processTableWithFilters(siblingTable, filterNumericObjects, 'numerical');
        }
        addColorToHeaders(tableHeaders, colorKey);
        // Use index-wise joining for leaf node data when both main and sibling are leaf nodes
        var useIndexWiseJoining = inputData.useIndexWiseJoining || false;
        var isLeafNodeData = inputData.isLeafNodeData || false;
        var joinedTable = useIndexWiseJoining
            ? joinMainAndSiblingIndexWise(mainTable, siblingTable, mainNodeName, siblingNodeName, isLeafNodeData)
            : joinMainAndSibling(mainTable, siblingTable, mainNodeName, siblingNodeName);
        if (shouldTotal) {
            joinedTable.push(totalRow);
        }
        return {
            colHeaders: tableHeaders,
            displayHeaders: tableHeaders.filter(function (item) { return !item.hide; }),
            rows: joinedTable,
            hidePortfolioElements: hidePortfolioElements
        };
    };
    ChartTable.generateCsv = function (formattedTable, csvFormat, terminology) {
        if (terminology === void 0) { terminology = null; }
        if (!formattedTable) {
            return '';
        }
        var colHeaders = formattedTable.colHeaders, rows = formattedTable.rows, hidePortfolioElements = formattedTable.hidePortfolioElements;
        var cellSeparator = csvFormat === 'EU' ? ';' : ',';
        var decimalPoint = csvFormat === 'EU' ? ',' : '.';
        // Use terminology if provided, otherwise fall back to default
        var portfolioElementsText = terminology ? terminology.Portfolio + " Elements" : 'Portfolio Elements';
        // Only add Portfolio Elements column if not hidden
        var colHeadersMod = hidePortfolioElements ?
            colHeaders :
            [{ key: 'name', text: portfolioElementsText }].concat(colHeaders);
        var lines = [];
        lines.push(colHeadersMod.map(function (header) { return formatCell(header['text'], decimalPoint); }).join(cellSeparator));
        rows.forEach(function (row) {
            if (row.main) {
                lines.push(colHeadersMod.map(function (x) { return formatCell(row.main[x.key], decimalPoint); }).join(cellSeparator));
            }
            if (row.sibling) {
                lines.push(colHeadersMod.map(function (x) { return formatCell(row.sibling[x.key], decimalPoint); }).join(cellSeparator));
            }
        });
        return lines.join('\n');
    };
    return ChartTable;
}());
exports.ChartTable = ChartTable;
//# sourceMappingURL=chart-table.logic.js.map


// WEBPACK FOOTER //
// ./app/components/chart-table/chart-table.logic.js